import { RootState } from 'StoreTypes';
import { PatientAccessError } from './authorizationSlice';

export const selectPatientAuthorizationError = (
  state: RootState,
): PatientAccessError | null | undefined => {
  return state?.authorizationStatus?.patientAccessError;
};
